import type { AuthUser, Role } from './types';

const STAFF: Role[] = ['AdminGlobal', 'Contador'];

export function hasRole(user: AuthUser | null, role: Role): boolean {
  return !!user && user.groups.includes(role);
}

export function isAdmin(user: AuthUser | null): boolean {
  return hasRole(user, 'AdminGlobal');
}

export function isContador(user: AuthUser | null): boolean {
  return hasRole(user, 'Contador');
}

export function isStaff(user: AuthUser | null): boolean {
  return !!user && STAFF.some(r => user.groups.includes(r));
}

export function isCliente(user: AuthUser | null): boolean {
  return !!user && !isStaff(user);
}

export function effectiveRole(user: AuthUser | null): Role | null {
  if (!user) return null;
  if (isAdmin(user))    return 'AdminGlobal';
  if (isContador(user)) return 'Contador';
  return 'Cliente';
}

export function getUserRfcs(user: AuthUser | null): string[] {
  if (!user || !user.rfc) return [];
  return user.rfc.split(',').map(r => r.trim().toUpperCase()).filter(Boolean);
}

export function canAccessRfc(user: AuthUser | null, rfc: string): boolean {
  if (!user || !rfc) return false;
  if (isAdmin(user)) return true;
  return getUserRfcs(user).includes(rfc.toUpperCase());
}
